import type { Project } from '@/components/ProjectHeadline/types'

const projects: Project[] = [
  {
    title: 'fonction',
    description: 'A modern practical functional library',
    repo: 'https://github.com/TomokiMiyauci/fonction',
    npm: 'https://www.npmjs.com/package/fonction',
    hero: '',
    type: 'universal',
    language: 'ts',
    runtime: ['deno', 'node']
  },
  {
    title: 'equal',
    description:
      'TypeScript-first deep equivalence comparison between two values',
    repo: 'https://github.com/TomokiMiyauci/equal',
    npm: 'https://www.npmjs.com/package/lauqe',
    hero: '',
    type: 'universal',
    language: 'ts',
    runtime: ['deno', 'node']
  },
  {
    title: 'curry',
    description: 'TypeScript-first curry function without upcast',
    repo: 'https://github.com/TomokiMiyauci/curry',
    npm: 'https://www.npmjs.com/package/curry-rice',
    hero: '',
    type: 'universal',
    language: 'ts',
    runtime: ['deno', 'node']
  },
  {
    title: 'registerable',
    description:
      'Check if it can be registered as a package name or domain name',
    repo: 'https://github.com/TomokiMiyauci/registerable',
    npm: 'https://www.npmjs.com/package/registerable',
    hero: '',
    type: 'universal',
    language: 'ts',
    runtime: ['deno', 'node']
  },
  {
    title: 'is-valid',
    description:
      'A pure functional validator with composite function and validation utilities',
    repo: 'https://github.com/TomokiMiyauci/is-valid',
    npm: 'https://www.npmjs.com/package/@miyauci/is-valid',
    hero: '',
    type: 'universal',
    language: 'ts',
    runtime: ['deno', 'node']
  },
  {
    title: 'is-valid-package-name',
    description: 'Validation for package name',
    repo: 'https://github.com/TomokiMiyauci/is-valid-package-name',
    npm: 'https://www.npmjs.com/package/is-valid-package-name',
    hero: '',
    type: 'universal',
    language: 'ts',
    runtime: ['deno', 'node']
  },
  {
    title: 'core-fn',
    description:
      'A collection of built-in object method and property as currying function',
    repo: 'https://github.com/TomokiMiyauci/core-fn',
    npm: 'https://www.npmjs.com/package/core-fn',
    hero: '',
    type: 'universal',
    language: 'ts',
    runtime: ['deno', 'node']
  }
]
export { projects }
